module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-nate-diaz-1.8b86c523.png";